module.exports = __webpack_public_path__ + "img/ThemeIcons.8c796f3b.svg";